import type { ReceiptTemplate } from '../schema';

export const kingSoopersTemplate: ReceiptTemplate = {
  id: 'king-soopers',
  name: 'King Soopers Receipt',
  brand: 'King Soopers',
  description: 'King Soopers grocery store receipt template',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'narrow',
  },
  sections: [
    {
      id: 'ks-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/king-soopers.png',
        logoData: '',
        logoWidth: 140,
        logoHeight: 50,
        businessName: '',
        businessNameFontSize: 20,
        addressLines: [
          'STORE #847',
          '1200 DARK AVENUE',
          'DENVER, CO 80202',
          '(303) 555-0147',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ks-trans',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: '01/04/2026 2:45 PM\nCASHIER: JENNIFER',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'ks-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: true,
        showPrice: true,
        showTotal: false,
        items: [
          { id: 'ks-item-1', name: 'BANANAS', quantity: '1', price: '1.29'},
          { id: 'ks-item-2', name: 'MILK 2% GAL', quantity: '1', price: '3.99'},
          { id: 'ks-item-3', name: 'BREAD WHEAT', quantity: '1', price: '2.49'},
          { id: 'ks-item-4', name: 'EGGS LARGE DZ', quantity: '1', price: '4.99'},
          { id: 'ks-item-5', name: 'CHICKEN BREAST', quantity: '1', price: '8.47'},
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ks-savings',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: '*** CARD SAVINGS: $2.47 ***',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: true,
      },
    },
    {
      id: 'ks-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 35,
        labelAlignment: 'left',
        lines: [
          { id: 'ks-subtotal', label: 'SUBTOTAL', value: '21.23', isBold: false, isLarge: false },
          { id: 'ks-savings', label: 'CARD SAVINGS', value: '-2.47', isBold: false, isLarge: false },
          { id: 'ks-tax', label: 'TAX', value: '0.94', isBold: false, isLarge: false },
          { id: 'ks-total', label: 'TOTAL', value: '19.70', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 20,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'ks-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        paymentType: 'card',
        cardFields: [
          { id: 'ks-card', label: 'DEBIT', value: '************8472' },
          { id: 'ks-auth', label: 'AUTH', value: '284719' },
        ],
        cashFields: [],
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'ks-fuel',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'FUEL POINTS EARNED: 21\nTOTAL FUEL POINTS: 847',
        fontSize: 10,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'ks-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: '84701042614523',
        showValue: false,
        width: 1.5,
        height: 35,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ks-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'THANK YOU FOR SHOPPING\nKING SOOPERS',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};
